module.exports = __webpack_public_path__ + "static/media/shop-vip-divider.c20bccf1.png";